<div class="get-extension-container">
  <div class="message">
    <h3>Enhance your experience!</h3>
    <p>Install the NuageDx Medical Chrome Extension for better performance and features.</p>
  </div>
  <div class="actions">
    <button mat-raised-button color="primary" (click)="openExtensionStore()">
      Get Extension
    </button>
    <button mat-button (click)="closeDialog()">
      Close
    </button>
  </div>
</div>
